/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Formatter_TitleInputs */

const en_formatter_title = /** @type {(inputs: Formatter_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Online JSON Formatter`)
};

const ko_formatter_title = /** @type {(inputs: Formatter_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`온라인 JSON 포맷터`)
};

const ja_formatter_title = /** @type {(inputs: Formatter_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`オンラインJSONフォーマッター`)
};

/**
* | output |
* | --- |
* | "Online JSON Formatter" |
*
* @param {Formatter_TitleInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const formatter_title = /** @type {((inputs?: Formatter_TitleInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Formatter_TitleInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_formatter_title(inputs)
	if (locale === "ko") return ko_formatter_title(inputs)
	return ja_formatter_title(inputs)
});